// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__X-uev","icon":"LanguageSwitcher_icon__dZjpk"};